import { useEffect } from "react";

import { useGetShipmentLists } from "../../hooks";
import { setCachedItem } from "../../helpers";

export const useShipmentListWithCache = ({ locationId }) => {
  const { data, isLoading, isSuccess } = useGetShipmentLists({
    locationId,
    enabled: !!locationId,
  });

  useEffect(() => {
    if (data && isSuccess) setCachedItem(`shipments-${locationId}`, data);
  }, [data, isSuccess, locationId]);

  return { shipments: data || [], isLoading, isSuccess };
};
